export const sortCb = sorting => (a, b) => {
	const { column, ascending } = sorting;

	const aValue = a[column] && a[column].toString().toLowerCase();
	const bValue = b[column] && b[column].toString().toLowerCase();

	const direction = ascending ? -1 : 1;
	return aValue > bValue ? direction : -1 * direction;
};

export const sortData = (list, sorting) => {
	const result = [...list];

	result.sort(sortCb(sorting));

	return result;
};

export const TABLE_COLS = [
	{
		title: 'Initiative name',
		id: 'name',
	},
	{
		title: 'Spend type',
		id: 'spendType',
	},
	{
		title: 'Initiative type',
		id: 'type',
	},
	{
		title: 'Low',
		id: 'low',
	},
	{
		title: 'High',
		id: 'high',
	},
];

let cachedScrollbarWidth = null;
// code from https://stackoverflow.com/questions/13382516/getting-scroll-bar-width-using-javascript
export const getScrollbarWidth = () => {
	if (cachedScrollbarWidth) {
		return cachedScrollbarWidth;
	}

	// Creating invisible container
	const outer = document.createElement('div');
	outer.style.visibility = 'hidden';
	outer.style.overflow = 'scroll'; // forcing scrollbar to appear
	outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
	document.body.appendChild(outer);

	// Creating inner element and placing it in the container
	const inner = document.createElement('div');
	outer.appendChild(inner);

	// Calculating difference between container's full width and the child width
	const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

	// Removing temporary elements from the DOM
	outer.parentNode.removeChild(outer);

	cachedScrollbarWidth = scrollbarWidth;

	return cachedScrollbarWidth;
};
